<div class="wrapper">
    <div class="content">
        <div class="login-wrapper">
            <app-login-button></app-login-button>
        </div>
        <img src="assets/MARK-STUDIOS.svg" alt="">

        <div class="search-wrapper">

        </div>
        <app-search-bar class="search"></app-search-bar>
    </div>
</div>